import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import { Checkbox, FormControlLabel, Grid } from "@material-ui/core";

import Paper from "@material-ui/core/Paper"


import Typography from "@material-ui/core/Typography";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import Calendar from "react-modern-calendar-datepicker";

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import TextField from '@material-ui/core/TextField';

import Select from "react-select";



const FilterPanel2 = ({
                         searchText,
                         Renewal,
                         onSearchTextChange,
                         selectedDayStart,
                         onStartDateChange,
                         selectedDayEnd,
                         onEndDateChange,
                         selectedStatus,
                         onStatusChange,
                         statusOptions,
                         onSearch,
                         onBase
                     }) => {
    console.log("Renewal:", Renewal); // برای بررسی مقدار تاریخ شروع
    return (
        <Paper elevation={4} style={{ padding: 24, borderRadius: 16, marginBottom: 24 }}>
            <Grid container spacing={3} alignItems="center" dir="rtl">
                {/* جستجو */}
                <Grid item xs={2}>
                    <TextField
                        fullWidth
                        value={searchText}
                        onChange={(e) => onSearchTextChange(e.target.value)} // تغییر searchText
                    />
                </Grid>

            </Grid>
        </Paper>
    );
};


export default FilterPanel2;
